import { Card, Grid } from "@mui/material"
import MDBox from "components/MDBox"
import axios from "axios"
import { ToastUtil } from "utilities/toastUtil"

import MDTypography from "components/MDTypography"
import { useSearchParams } from "react-router-dom"
import FormField from "layouts/pages/account/components/FormField"
import typography from "assets/theme/base/typography"
import pxToRem from "assets/theme/functions/pxToRem"
import ChevronDownIcon from "assets/images/apollo-english/chevron-down.svg"
import DataTable from "./table"
import { useState, useEffect, useMemo } from "react"
import { titleTypography, descriptionTypography, noteTypography } from "shared/styles/style"
import moment from "moment"
import { useLazyGetOoolabStudentDetailQuery } from "shared/redux/endpoints/sso"
import {
  useLazyGetStudentQuery,
  useLazyGetSuggestionsQuery,
  useLazyGetClassSuggessionForStudentQuery,
  useLazyGetStudentByClassCodeQuery,
  useLazyGetStudentByCodeQuery,
  useLazyGetStudentSuggessionForStudentQuery,
} from "shared/redux/endpoints/assistant"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import makeStyles from "pages/style"
import MDSelect from "components/MDSelect"
import { DateRangeSelect } from "../../DateSelect/range"
import { globalConfigs } from "configs"
import { useSelector } from "react-redux"

const customStyle = (disable) => ({
  minWidth: "150px",
  ...(disable && { backgroundColor: "#FAFAFA!important" }),
  borderRadius: "0.375rem",
  "& *": {
    fontFamily: "'Lexend', san-serif !important",
  },
  "& .MuiOutlinedInput-root": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "& input, & input::placeholder": {
    fontSize: "12px !important",
    lineHeight: "1.5!important",
    fontWeight: 400,
    fontFamily: typography.lexendFont,
  },

  "& input": {
    paddingLeft: `${pxToRem(14)} !important`,
  },
})

function Students() {
  const classes = makeStyles()
  const [trigger] = useLazyGetOoolabStudentDetailQuery()
  const [searchParams, setSearchParams] = useSearchParams()

  const groupKOC = searchParams.get("group-koc")
  const koc = searchParams.get("koc")
  const centre = searchParams.get("center")
  const levelName = searchParams.get("level-name") || ""
  const className = searchParams.get("class")
  const valueClassName = (className && className?.split(",")) || []
  const studentName = searchParams.get("student-name")
  const valueStudentName = (studentName && studentName?.split(",")) || []
  const page = searchParams.get("page") || 0
  const size = searchParams.get("size") || 10
  const startDate =
    searchParams.get("start-date") ||
    moment(new Date()).startOf("isoweek").format("MM-DD-YYYY")
  const endDate =
    searchParams.get("end-date") ||
    moment(new Date()).endOf("isoweek").format("MM-DD-YYYY")

  const [totalPage, setTotalPage] = useState(1)
  const user = useSelector((state) => state.auth.user)
  const { userId } = user

  const handlePrev = () => {
    searchParams.set("page", (page ?? 0) - 1)
    setSearchParams(searchParams)
  }

  const handleNext = () => {
    searchParams.set("page", (page ?? 0) + 1)
    setSearchParams(searchParams)
  }

  const setCurrentPage = (page) => {
    searchParams.set("page", page)
    setSearchParams(searchParams)
  }

  const setSize = (size) => {
    searchParams.set("size", size)
    setSearchParams(searchParams)
  }

  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "No", accessor: "no", width: "5%" },
      { Header: "Student Code", accessor: "studentCode", width: "12%" },
      { Header: "Student Name", accessor: "studentName", width: "14%" },
      { Header: "Nickname", accessor: "nickname", width: "8%" },

      // ===== Class / Center / Course =====
      { Header: "Center", accessor: "centerName", width: "12%" },
      { Header: "Class Name", accessor: "className", width: "14%" },
      { Header: "Class Code", accessor: "classCode", width: "12%" },
      { Header: "Course Group", accessor: "courseGroupName", width: "12%" },
      { Header: "Course", accessor: "courseName", width: "12%" },

      // ===== Week / Date =====
      { Header: "Start Date", accessor: "startDate", width: "10%" },
      { Header: "Week Start", accessor: "weekStart", width: "10%" },
      { Header: "Week End", accessor: "weekEnd", width: "10%" },

      // ===== Status rendered (đúng như UI bạn đang hiển thị) =====
      { Header: "Engagement", accessor: "engagement", width: "10%" },
      // { Header: "Performance", accessor: "performance", width: "10%" },
      // { Header: "Home Learning", accessor: "homeLearning", width: "10%" },

      // ===== Raw statuses (nếu muốn show text thô) =====
      // { Header: "Attendance Status", accessor: "attendanceStatus", width: "10%" },
      // { Header: "Engagement Status", accessor: "engagementStatus", width: "10%" },
      // { Header: "Achievement Status", accessor: "achievementStatus", width: "10%" },

      // ===== Scores / results (optional) =====
      { Header: "Attendance Score", accessor: "attendanceScore", width: "15%" },
      {
        Header: "Engagement Result",
        accessor: "engagementResult",
        width: "15%",
      },
      {
        Header: "Achievement Result",
        accessor: "achievementResult",
        width: "15%",
      },
      {
        Header: "HL Completion",
        accessor: "homeLearningCompletion",
        width: "15%",
      },
      { Header: "HL Score", accessor: "homeLearningScore", width: "15%" },
      { Header: "Overall Type", accessor: "overallType", width: "15%" },
      { Header: "Overall Result", accessor: "overallResult", width: "15%" },
      { Header: "Leaderboard", accessor: "leaderboardScore", width: "15%" },

      // ===== Other =====
      { Header: "Tutoring Flag", accessor: "tutoringFlag", width: "15%" },
      { Header: "APO Number", accessor: "apoNumber", width: "15%" },
      { Header: "App Completion", accessor: "appCompletion", width: "15%" },
      { Header: "App Score", accessor: "appScore", width: "15%" },
      { Header: "Teacher ID", accessor: "teacherId", width: "15%" },

      // ===== LMS =====
      { Header: "LMS", accessor: "LMS", width: "8%" },
    ],

    rows: [],
  })

  const [studentTable, setStudentTable] = useState([])
  const [suggestions, setSuggestions] = useState({
    centerName: [],
    groupKOC: [],
    koc: [],
    levelName: [],
  })

  const [centerNameOptions, setCenterNameOptions] = useState([])
  const [classSuggestions, setClassSuggestions] = useState([])
  const [studentSuggestions, setStudentSuggestions] = useState([])

  const [step, setStep] = useState(
    studentName ? 6 : className ? 5 : levelName ? 4 : koc ? 3 : groupKOC ? 2 : centre ? 1 : 0
  )

  const [triggerGetStudent, { isFetching: isFetchingStudent }] =
    useLazyGetStudentQuery()
  const [triggerSuggestions, { isFetching: isFetchingSuggestions }] =
    useLazyGetSuggestionsQuery()
  const [
    triggerGetClassSuggession,
    { isFetching: isFetchingClassSuggestions },
  ] = useLazyGetClassSuggessionForStudentQuery()
  const [
    triggerGetStudentSuggession,
    { isFetching: isFetchingStudentSuggestions },
  ] = useLazyGetStudentSuggessionForStudentQuery()
  const [
    triggerGetStudentByClassCode,
    { isFetching: isFetchingStudentByClassCode },
  ] = useLazyGetStudentByClassCodeQuery()
  const [
    triggerGetStudentByStudentCode,
    { isFetching: isFetchingStudentByStudentCode },
  ] = useLazyGetStudentByCodeQuery()

  const handleFetchSuggestions = async (data) => {
    const response = await triggerSuggestions(data)
    if (response?.data?.status) {
      setSuggestions({
        centerName:
          response?.data?.data?.centerName?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        groupKOC:
          response?.data?.data?.groupKOC?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        koc:
          response?.data?.data?.koc?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        levelName:
          response?.data?.data?.levelName?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
      })
    }

    return response
  }

  const handleFetchClassSuggestions = async (data) => {
    const response = await triggerGetClassSuggession(data)
    if (response?.data?.status) {
      setClassSuggestions(response?.data?.data)
    }
  }

  const handleFetchStudentSuggestions = async (data) => {
    const response = await triggerGetStudentSuggession(data)
    if (response?.data?.status) {
      console.log(`student`, response?.data?.data)
      setStudentSuggestions(response?.data?.data)
    }
  }

  const queryParams = useMemo(
    () => ({
      page: page ?? 0,
      size: size ?? 0,
      sort: "",
      startDate: startDate ? moment(startDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
      endDate: endDate ? moment(endDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
      groupKOC: groupKOC ?? "",
      centerName: centre ?? "",
      KOC: koc ?? "",
      levelName: levelName ?? "",
      classCode: className,
      studentCode: studentName,
    }),
    [page, size, startDate, endDate, groupKOC, centre, koc, levelName, className, studentName]
  )

  useEffect(() => {
    const fetchStudents = async () => {
      if (queryParams.studentCode) {
        const response = await triggerGetStudentByStudentCode({
          code: queryParams.studentCode,
          startDate: queryParams.startDate,
          endDate: queryParams.endDate,
        })
        if (response?.data?.status) {
          setStudentTable(response?.data?.data ?? [])
          setTotalPage(1)
        }
      } else if (queryParams.classCode) {
        const response = await triggerGetStudentByClassCode({
          code: queryParams.classCode,
          startDate: queryParams.startDate,
          endDate: queryParams.endDate,
          page: queryParams.page,
          size: queryParams.size,
        })
        if (response?.data?.status) {
          setStudentTable(response?.data?.data?.data ?? [])
          setTotalPage(response?.data?.data?.totalPage ?? 1)
        }
      } else {
        const response = await triggerGetStudent({
          ...queryParams,
        })

        if (response?.data?.status) {
          setStudentTable(response?.data?.data?.data ?? [])
          setTotalPage(response?.data?.data?.totalPage ?? 1)
        }
      }
    }
    void fetchStudents()
  }, [queryParams])

  useEffect(() => {
    handleFetchSuggestions({
      centerName: centre || "",
      groupKOC: groupKOC || "",
    }).then((result) => {
      if (result?.data?.status) {
        setCenterNameOptions(
          result?.data?.data?.centerName?.map((item) => ({
            label: item,
            value: item,
          })) ?? []
        )
      }
    })
  }, [])

  useEffect(() => {
    if (centre && groupKOC && koc && levelName && startDate && endDate) {
      handleFetchClassSuggestions({
        startDate: startDate ? moment(startDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
        endDate: endDate ? moment(endDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
        groupKOC: groupKOC || "",
        KOC: koc || "",
        centerName: centre,
        levelName: levelName || "",
      })
    }
  }, [centre, groupKOC, koc, levelName, startDate, endDate])

  useEffect(() => {
    if (className) {
      handleFetchStudentSuggestions({
        classCode: className,
        startDate: startDate ? moment(startDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
        endDate: endDate ? moment(endDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
      })
    }
  }, [className, startDate, endDate])

  // useEffect(() => {
  //   if (!date) {
  //     searchParams.set("date", moment(new Date()).startOf("isoweek").format("MM-DD-YYYY"));
  //     setSearchParams(searchParams);
  //   }
  //   if (!size) {
  //     searchParams.set("size", 10);
  //     setSearchParams(searchParams);
  //   }
  //   if (!page) {
  //     searchParams.set("page", 0);
  //     setSearchParams(searchParams);
  //   }
  // }, [date, size, page]);

  const isFetching = useMemo(
    () =>
      isFetchingStudent ||
      isFetchingSuggestions ||
      isFetchingClassSuggestions ||
      isFetchingStudentSuggestions ||
      isFetchingStudentByClassCode ||
      isFetchingStudentByStudentCode,
    [
      isFetchingStudent,
      isFetchingSuggestions,
      isFetchingClassSuggestions,
      isFetchingStudentSuggestions,
      isFetchingStudentByClassCode,
      isFetchingStudentByStudentCode,
    ]
  )

  const renderStatus = (status) => (
    <MDTypography
      variant="span"
      sx={({ breakpoints }) => ({
        ...descriptionTypography(breakpoints),
        lineHeight: 1.5,
        color: status === "OFFTRACK" ? "#F5365C" : "#172B4D",
        paddingRight: 2,
        display: "block",
        [breakpoints.down(1600)]: { fontSize: 12 },
      })}
    >
      {status || ""}
    </MDTypography>
  )

  useEffect(() => {
    if (studentTable) {
      const customDataRow = studentTable.map((item, index) => {
        return {
          no: parseInt(size) * parseInt(page) + index + 1,
          id: item?.studentId, // (bạn đang dùng studentId làm id)

          // ===== IDs / Keys =====
          responseId: item?.id, // id của record
          studentId: item?.studentId,
          studentHubId: item?.studentHubId,
          classId: item?.classId,
          centerId: item?.centerId,
          teacherId: item?.teacherId,

          // ===== Student =====
          studentCode: item?.studentCode,
          studentName: item?.studentName,
          nickname: item?.nickName ?? "",

          // ===== Class / Center / Course =====
          classCode: item?.classCode,
          className: item?.className,
          centerName: item?.centerName,
          courseGroupName: item?.courseGroupName,
          courseName: item?.courseName,

          // ===== Dates / Week =====
          startDate: item?.startDate,
          weekStart: item?.weekStart,
          weekEnd: item?.weekEnd,

          // ===== Status strings (raw) =====
          attendanceStatus: item?.attendanceStatus,
          engagementStatus: item?.engagementStatus,
          achievementStatus: item?.achievementStatus,
          overallType: item?.overallType,
          tutoringFlag: item?.tutoringFlag,
          scoreTimestamp: item?.scoreTimestamp,

          // ===== Scores / Results =====
          attendanceScore: item?.attendanceScore,
          engagementResult: item?.engagementResult,
          achievementResult: item?.achievementResult,
          homeLearningCompletion: item?.homeLearningCompletion,
          homeLearningScore: item?.homeLearningScore,
          apoNumber: item?.apoNumber,
          appCompletion: item?.appCompletion,
          appScore: item?.appScore,
          overallResult: item?.overallResult,
          leaderboardScore: item?.leaderboardScore,

          // ===== Rendered cells for current columns =====
          engagement: renderStatus(item?.engagementStatus),
          performance: renderStatus(item?.achievementStatus), // "Performance" = achievementStatus
          homeLearning: renderStatus(item?.attendanceStatus), // nếu bạn muốn HL = attendanceStatus thì ok
          // Nếu Home Learning phải dựa vào homeLearningScore/completion thì đổi bên dưới (gợi ý)
          LMS: (
            <MDBox
              sx={{
                backgroundColor: "#2576B9",
                color: "#FFFFFF !important",
                padding: "5px 10px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={async (e) => {
                e.preventDefault()
                e.stopPropagation()
                const { studentId } = item
                axios
                  .post(
                    globalConfigs.urlSSOLms +
                    "/auth/redirect-my-apollo/generate",
                    {
                      hubUserId: userId,
                      type: "STUDENT_DETAIL",
                      hubStudentId: studentId,
                    },
                    {
                      headers: {
                        "x-api-key": globalConfigs.apiKeySSO,
                      },
                    }
                  )
                  .then((res) => {
                    const _data = res?.data?.redirectLink
                    if (_data) {
                      window.open(_data, "_blank")
                    }
                  })
                  .catch((err) => {
                    ToastUtil.showToastError("Can't open LMS. Please try again")
                  })
              }}
            >
              Go to LMS
            </MDBox>
          ),
        }
      })
      setDataTable({
        ...dataTable,
        rows: customDataRow || [],
      })
    }
  }, [studentTable])

  return (
    <MDBox mb={3}>
      <Card>
        <MDBox p={3} lineHeight={1}>
          <InfoIcon
            type={TooltipType.TYPE_1}
            teacherInfoIconBlock={teacherInfoIconBlock.STUDENT_LIST}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWithHeading}
          >
            <MDTypography
              sx={({ breakpoints }) => ({ ...titleTypography(breakpoints) })}
            >
              Student list
            </MDTypography>
          </InfoIcon>
        </MDBox>
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          px={3}
          pb={3}
          sx={({ breakpoints }) => ({
            [breakpoints.down("lg")]: {
              justifyContent: "flex-start",
            },
          })}
        >
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <DateRangeSelect
              onChangeStartDate={(e) => {
                searchParams.set("start-date", moment(e).format("MM-DD-YYYY"))
                setSearchParams(searchParams)
              }}
              onChangeEndDate={(e) => {
                searchParams.set("end-date", moment(e).format("MM-DD-YYYY"))
                setSearchParams(searchParams)
              }}
              defaultStartDate={startDate}
              defaultEndDate={endDate}
              disable={isFetching}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.7}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Centre
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={centerNameOptions || []}
              isDisabled={
                suggestions?.centerName?.length === 0 || isFetching || step < 0
              }
              onChange={(e) => {
                searchParams.set("center", e.value ?? "")
                searchParams.delete("group-koc")
                searchParams.delete("koc")
                searchParams.delete("level-name")
                searchParams.delete("class")
                searchParams.delete("student-name")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: e.value || "",
                  groupKOC: "",
                  KOC: "",
                })
                if (e.value) {
                  setStep(1)
                } else {
                  setStep(0)
                }
              }}
              placeholder="Select Centre"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.7}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Group KOC
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.groupKOC || []}
              isDisabled={
                suggestions?.groupKOC?.length === 0 || isFetching || step < 1
              }
              onChange={(e) => {
                searchParams.set("group-koc", e.value ?? "")
                searchParams.delete("koc")
                searchParams.delete("level-name")
                searchParams.delete("class")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: centre || "",
                  groupKOC: e.value || "",
                  KOC: "",
                })
                if (e.value) {
                  setStep(2)
                } else {
                  setStep(1)
                }
              }}
              placeholder="Group KOC"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.3}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              KOC
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.koc || []}
              isDisabled={
                suggestions?.koc?.length === 0 || isFetching || step < 2
              }
              onChange={(e) => {
                searchParams.set("koc", e.value ?? "")
                searchParams.delete("level-name")
                searchParams.delete("class")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: centre || "",
                  groupKOC: groupKOC || "",
                  KOC: e.value || "",
                })
                if (e.value) {
                  setStep(3)
                } else {
                  setStep(2)
                }
              }}
              placeholder="KOC"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.3}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Level
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.levelName || []}
              isDisabled={
                suggestions?.levelName?.length === 0 || isFetching || step < 3
              }
              value={levelName ? { label: levelName, value: levelName } : null}
              onChange={(e) => {
                if (e?.value) {
                  searchParams.set("level-name", e.value)
                  setStep(4)
                } else {
                  searchParams.delete("level-name")
                  setStep(3)
                }
                searchParams.delete("class")
                setSearchParams(searchParams)
              }}
              placeholder="Level"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.5}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Class
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={classSuggestions.map((item) => ({
                value: item.value,
                label: item.value,
              }))}
              isDisabled={
                classSuggestions?.length === 0 || isFetching || step < 4
              }
              onChange={(e) => {
                searchParams.set("class", e.value ?? "")
                setSearchParams(searchParams)
                if (e.value) {
                  setStep(5)
                } else {
                  setStep(4)
                }
              }}
              placeholder="Class"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.5}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Student
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={studentSuggestions.map((item) => ({
                value: item.value,
                label: item.value,
              }))}
              disabled={
                studentSuggestions?.length === 0 || isFetching || step < 5
              }
              onChange={(e) => {
                searchParams.set("student-name", e.value ?? "")
                setSearchParams(searchParams)
                if (e.value) {
                  setStep(6)
                } else {
                  setStep(5)
                }
              }}
              placeholder="Student"
            />
          </Grid>
        </Grid>

        <DataTable
          table={dataTable}
          isSorted={false}
          currentPage={parseInt(queryParams.page ?? 0)}
          handlePrev={handlePrev}
          handleNext={handleNext}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
          isLoading={isFetching}
          isEmpty={studentTable?.length === 0}
          studentPageSize={parseInt(queryParams.size ?? 10)}
          setStudentPageSize={setSize}
        />
      </Card>
    </MDBox>
  )
}

export { Students }
